import { useEffect } from 'react'
import { X } from 'lucide-react'
import type { UseChecklistScan } from '@/screens/scan/useChecklistScan'
import { SelectView } from './SelectView'

/**
 * Bottom-sheet drawer holding the checklist-item picker. Opened by the Scan
 * button; dispatching a scan (SelectView's footer) closes it via the hook and
 * the new run appears in the history behind it.
 */
export function ScanDrawer({ scan }: { scan: UseChecklistScan }) {
  // Close on Escape, matching the backdrop click.
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') scan.closeDrawer()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [scan])

  return (
    <div className='ramp-scan-drawer-overlay' onClick={scan.closeDrawer}>
      <div
        className='ramp-scan-drawer'
        role='dialog'
        aria-modal='true'
        aria-label='Select checklist items to scan'
        onClick={(event) => event.stopPropagation()}
      >
        <div className='ramp-scan-drawer-bar'>
          <span className='ramp-scan-drawer-handle' />
          <button
            type='button'
            className='ramp-scan-drawer-close'
            onClick={scan.closeDrawer}
            aria-label='Close'
          >
            <X size={16} />
          </button>
        </div>
        <SelectView scan={scan} />
      </div>
    </div>
  )
}
